var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isYoutubeVideo && _vm.getVideoId)?_c('youtube',{attrs:{"video-id":_vm.getVideoId}}):(_vm.isVimeoVideo && _vm.getVideoId)?_c('vimeo-player',{attrs:{"video-id":_vm.getVideoId}}):_c('a',{attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.url))])}
var staticRenderFns = []

export { render, staticRenderFns }